import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m12 12 4 10 1.7-4.3L22 16Z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Inspect";
const Inspect = memo(themed(Icon));
export {
  Inspect
};
//# sourceMappingURL=inspect.js.map
